/* YardSight Specific Actions */
export const YMS_DECKING_OPTIMIZATION_TESTER =
  "YMS_DECKING_OPTIMIZATION_TESTER";
export const YMS_DECKING_OPTIMIZATION_TESTER_SUCCESS =
  "YMS_DECKING_OPTIMIZATION_TESTER_SUCCESS";
export const YMS_DECKING_OPTIMIZATION_TESTER_ERROR =
  "YMS_DECKING_OPTIMIZATION_TESTER_ERROR";

export const YMS_DECKING_FILTER = "YMS_DECKING_FILTER";
export const YMS_DECKING_FILTER_SUCCESS = "YMS_DECKING_FILTER_SUCCESS";
export const YMS_DECKING_FILTER_ERROR = "YMS_DECKING_FILTER_ERROR";
